import script from "./WatchlistItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./WatchlistItem.vue?vue&type=script&setup=true&lang=ts"

import "./WatchlistItem.vue?vue&type=style&index=0&id=1a3fd6a8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a3fd6a8"]])

export default __exports__